import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import Modal from "react-modal";

Modal.setAppElement("#root");

const CateringImageCard = ({ setShowLogin, combo }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [quantities, setQuantities] = useState({});

  const userId = localStorage.getItem("userId");

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleIncrease = () => setQuantity(quantity + 1);
  const handleDecrease = () => {
    if (quantity > 1) setQuantity(quantity - 1);
    else setQuantity(0);
  };

  const goToCart = () => {
    setIsModalOpen(false);
    navigate("/cartsdata");
  };

  const addToCart = async (item, quantity = 1) => {
    console.log("addToCart called with dishId:", item.dishId);

    if (!userId) {
      setShowLogin(true);
      return;
    }

    const orderType = "DINE_IN";
    const apiUrl = ` https://backend.maamaas.com/food/api/cart/add/${userId}?orderType=${orderType}`;

    const data = {
      dishId: item.dishId,
      quantity: quantity,
    };

    try {
      const response = await axios.post(apiUrl, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
        console.log("Item successfully added to cart:", response.data);

        setCartItems((prevItems) => {
          const existingItem = prevItems.find(
            (cartItem) => cartItem.dishId === item.dishId
          );
          if (existingItem) {
            return prevItems.map((cartItem) =>
              cartItem.dishId === item.dishId
                ? { ...cartItem, quantity }
                : cartItem
            );
          } else {
            return [...prevItems, { ...item, quantity }];
          }
        });

        setQuantities((prev) => ({
          ...prev,
          [item.dishId]: quantity,
        }));

        setQuantity(quantity);
        setIsModalOpen(true);
        setTimeout(() => {
          if (!hovered) {
            setIsModalOpen(false);
          }
        }, 2000);
      } else {
        console.error("Failed to add item to cart:", response.data);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
      if (error.response) {
        if (error.response.status === 500) {
          alert("✅Please select your orderType here....");
        } else if (error.response.status === 404) {
          alert("Item not found. Please try again.");
        } else {
          alert(`Error: ${error.response.data}`);
        }
      } else {
        alert("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: 8,
        outline: "none",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          height: 360,
          width: 360,
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          background: "#000",
          boxShadow: hovered
            ? "0 16px 30px rgba(0,0,0,0.25)"
            : "0 12px 25px rgba(0,0,0,0.1)",
          transform: hovered ? "scale(1.03)" : "scale(1)",
          transition: "all .3s",
          cursor: "pointer",
        }}
      >
        <img
          src={combo.dishImage}
          alt={combo.dishName || combo.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.45)",
            zIndex: 2,
          }}
        />

        <div
          style={{
            position: "absolute",
            inset: 0,
            padding: 16,
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            zIndex: 3,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                background: "linear-gradient(90deg, green, green)",
                color: "#fff",
                fontSize: 14,
                fontWeight: "600",
                padding: "6px 14px",
                borderRadius: "20px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                letterSpacing: "0.5px",
              }}
            >
              🏷️{combo.discount}% Off on Combos
            </div>
          </div>
          
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
            }}
          >
          </div>

          <div>
            <h3
              style={{
                fontSize: 20,
                fontWeight: 700,
                marginBottom: 8,
              }}
            >
              {combo.dishName || combo.title}
            </h3>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    background: "green",
                    padding: "6px 12px",
                    borderRadius: 6,
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "#fff",
                    whiteSpace: "nowrap",
                  }}
                >
                  ₹{combo.price || 199}
                </div>

                {quantity === 0 ? (
                  <button
                    onClick={() => addToCart(combo, 1)}
                    style={{
                      padding: "8px 14px",
                      backgroundColor: "rgb(177 92 214)",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      fontWeight: "bold",
                      cursor: "pointer",
                      flex: 1,
                      transition: "background .3s",
                    }}
                  >
                    Add to Cart
                  </button>
                ) : (
                  <Modal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    contentLabel="Add to Cart"
                    style={{
                      overlay: { backgroundColor: "transparent" },
                      content: {
                        position: "absolute",
                        top: "90%",
                        left: "50%",
                        height: "100px",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: "500px",
                        border: "none",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                        padding: "20px",
                        borderRadius: "10px",
                        background: "#fff",
                      },
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <button
                        onClick={goToCart}
                        style={{
                          background: "rgb(177 92 214)",
                          border: "none",
                          borderRadius: "50%",
                          width: "45px",
                          height: "45px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <FaShoppingCart style={{ color: "#fff", fontSize: 20 }} />
                      </button>

                      <h3 style={{ margin: 0, fontSize: 18, fontWeight: "bold", flex: 1 }}>
                        {combo.dishName || combo.title}
                      </h3>

                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <button
                          onClick={handleDecrease}
                          style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            border: "none",
                            background: "#eee",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                        >
                          -
                        </button>
                        <span style={{ fontSize: "16px" }}>{quantity}</span>
                        <button
                          onClick={handleIncrease}
                          style={{
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            border: "none",
                            background: "#eee",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                        >
                          +
                        </button>
                      </div>

                      <div style={{ fontSize: 16, fontWeight: "bold" }}>
                        ₹{combo.price || 199}
                      </div>
                      <button
                        style={{
                          borderRadius: "50px",
                          background: "#ee6521",
                          color: "#fff",
                          padding: "8px 16px",
                          border: "none",
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                        onClick={goToCart}
                      >
                        View Cart
                      </button>
                    </div>
                  </Modal>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function CateringCombos() {
  const [combosData, setCombosData] = useState([]);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const id = localStorage.getItem("vendorId");
    if (id) setVendorId(id);
  }, []);

  useEffect(() => {
    const fetchCombos = async () => {
      try {
        const vendorId = 6;
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
          ` https://backend.maamaas.com/food/dish/getbyvendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Full API Response:", JSON.stringify(response.data, null, 2));

        const combosCategory = response.data.find(
          (item) => item.dishName?.toUpperCase() === "COMBOS"
        );

        if (!combosCategory) {
          console.warn("No COMBOS category found");
          return;
        }

        const combosList = response.data.filter(
          (item) => item.parentId === combosCategory.dishId
        );

        console.log("Resolved Combos List:", combosList);

        setCombosData(combosList);
      } catch (error) {
        console.error("❌ Error fetching combos:", error);
      }
    };

    fetchCombos();
  }, []);

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "linear",
    rtl: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section
      className="combos-wrapper"
      style={{ maxWidth: 999, margin: "0 auto", padding: "0px 20px" }}
    >
      <h1
        style={{
          textAlign: "center",
          fontSize: 38,
          fontWeight: 800,
          letterSpacing: 1,
          textTransform: "uppercase",
          textShadow: "0 4px 6px rgba(0,0,0,.1)",
          margin: "0 0 20px",
        }}
      >
        <span style={{ color: "rgb(42 9 71)" }}>Com</span>
        <span style={{ color: "red" }}>bos</span> Offers
      </h1>

      <Slider {...settings}>
        {combosData.length > 0 ? (
          combosData.map((combo) => (
            <CateringImageCard
              key={combo.id}
              combo={combo}
              onAddToCart={() =>
                alert(`Added ${combo.dishName} to cart (dynamic)`)
              }
            />
          ))
        ) : (
          <p style={{ textAlign: "center", width: "100%" }}>
            Loading combos...
          </p>
        )}
      </Slider>
    </section>
  );
}